import React from 'react';
import Papa from 'papaparse';
import { useSearchParams } from 'react-router-dom';
import { axios } from '@/services/axios';
import { downloadCSV } from '@/utils/utils';
import { FIELDS_TO_EXPORT, TEMPLATE_FILENAME } from './constants';

export default function useCSVTemplate() {
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');

    const [searchParams] = useSearchParams();
    const internationalRateListID = searchParams.get('listId');

    const handleDownloadTemplate = async () => {
        setLoading(true);
        setError('');
        try {
            let rows = [];
            if (internationalRateListID) {
                const response = await axios.get(
                    `/internationalrates/${internationalRateListID}`,
                );
                const existing = Array.isArray(response.data)
                    ? response.data
                    : [];
                rows = existing.map((rate) =>
                    Object.keys(FIELDS_TO_EXPORT).reduce((acc, key) => {
                        const csvHeader = FIELDS_TO_EXPORT[key];
                        if (key === 'isActive') {
                            acc[csvHeader] = rate[key] ? 1 : 0;
                        } else {
                            acc[csvHeader] = rate[key] ?? '';
                        }
                        return acc;
                    }, {}),
                );
            }

            if (rows.length === 0) {
                // Blank template row when no existing data
                rows = [
                    Object.values(FIELDS_TO_EXPORT).reduce((acc, header) => {
                        acc[header] = '';
                        return acc;
                    }, {}),
                ];
            }

            const csv = Papa.unparse(rows);
            downloadCSV(csv, TEMPLATE_FILENAME);
        } catch (err) {
            setError(err?.message || 'Failed to download template.');
        } finally {
            setLoading(false);
        }
    };

    return { handleDownloadTemplate, loading, error, internationalRateListID };
}
